/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const mobileSize = window.matchMedia( '(min-width: 1024px)' );
      slickHero( mobileSize );
      mobileSize.addEventListener( 'change', slickHero );

      function slickHero() {
        if ( window.innerWidth < 1024 ) {
          $( '.hero-banner' ).each( function() {
            if ( $( this ).find( '.hero-slides' ).length > 1 ) {
              const slider = $( this ).find( '.hero-banner__slider-mobile' );
              slider.slick( {
                dots: false,
                arrows: false,
                infinite: true,
                centerMode: true,
                focusOnSelect: true,
                responsive: [
                  {
                    breakpoint: 1270,
                    settings: 'unslick',
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 1,
                    },
                  },
                ],
              } );
              slider.on( 'afterChange', ( event, slick, currentSlide ) => {
                console.log( currentSlide );
                slider.closest( '.hero-banner' ).find( '.show-service-description.is-active' ).removeClass( 'is-active' );
                slider.closest( '.hero-banner' ).find( `[data-image=${currentSlide}]` ).addClass( 'is-active' );
              } );
            }
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
